<form class="modal-container" [formGroup]="form" *ngIf="!isLoading else loadingAnimation">
    <div class="form-container">
        <app-input
            [label]="'admin.strain.tickets.reports.modal.step3.gageConfiguration.nrOfGages' | translate"
            [placeholder]="'admin.strain.tickets.reports.modal.step3.gageConfiguration.nrOfGages' | translate"
            [formControl]="control('nrOfGages')"
            (inputChange)="changeRows($event)">
        </app-input>
        <div formArrayName="gages">
            <div *ngFor="let row of array('gages').controls; let i = index">
                <div class="gage_row" [formGroupName]="i">
                    <ng-container [ngTemplateOutlet]="itemRow"
                                  [ngTemplateOutletContext]="{index: i}">
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="canvas-container">
        <app-input-switch
            onLabel="{{'admin.strain.tickets.reports.modal.step3.gageConfiguration.bottomImage' | translate}}"
            offLabel="{{'admin.strain.tickets.reports.modal.step3.gageConfiguration.topImage' | translate}}"
            [formControl]="control('imageFormControl')"
            (inputChange)="changeImage()">
        </app-input-switch>
        <app-drawing-canvas #frontSideCanvas
                            [class.hidden]="visibleImage"
                            [formControl]="control('frontSideImage')"
                            [src]="getFrontSideImage()"
                            [arrows]="frontSideArrows">
        </app-drawing-canvas>
        <app-drawing-canvas #backSideCanvas
                            [class.hidden]="!visibleImage"
                            [formControl]="control('backSideImage')"
                            [src]="getBackSideImage()"
                            [arrows]="backSideArrows">
        </app-drawing-canvas>
    </div>
</form>

<ng-template #itemRow let-index='index'>
    <p>{{ index + 1 }}</p>
    <app-dropdown-autocomplete class="gageType"
                               valueField="id"
                               displayField="type"
                               emptyText="{{'admin.strain.configuration.tabs.gages.form.gage' | translate}}"
                               [formControl]="arrayControl(index, 'gage')"
                               [items]="gages"
                               [appendTo]="'body'"
                               [showErrors]="showValidations || arrayControl(index, 'gage').invalid && arrayControl(index, 'gage').touched"
                               (selectItem)="updateGageType($event, index)">
    </app-dropdown-autocomplete>
    <app-input class="componentName"
               [formControl]="arrayControl(index, 'name')"
               [placeholder]="'admin.strain.configuration.tabs.gages.form.name' | translate"
               [showErrors]="showValidations || arrayControl(index, 'name').touched && arrayControl(index, 'name').invalid">
    </app-input>
    <app-input-switch class="gagePosition"
                      [formControl]="arrayControl(index, 'position')"
                      (inputChange)="updateArrows()"
                      onLabel="{{'admin.strain.tickets.reports.modal.step3.gageConfiguration.bottom' | translate}}"
                      offLabel="{{'admin.strain.tickets.reports.modal.step3.gageConfiguration.top' | translate}}">
    </app-input-switch>
</ng-template>

<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
